import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import useTrackers from '@swf/core/hooks/useTrackers';

import { TXTCLI_Share_viaX } from './SocialShareButtons.messages.json';
import styles from './SocialShareButtons.scss';
import EmailShareButton from './buttons/EmailShareButton';
import FacebookShareButton from './buttons/FacebookShareButton';
import TwitterShareButton from './buttons/TwitterShareButton';

const SocialShareButtons: React.FC<{ url: string }> = ({ url }) => {
  const { linkClicked } = useTrackers();

  const onClick: React.MouseEventHandler = (event) => {
    const a = (event.target as HTMLElement).closest('a');
    const trackId = a?.getAttribute('data-track-id');

    if (a) {
      const href = a.getAttribute('href');
      linkClicked({
        destinationUrl: href || '',
        linkText: trackId
      });
    }
  };

  return (
    <div className={styles.socialShareButtons}>
      <div className={styles.shareText}>
        <Translation {...TXTCLI_Share_viaX} />
      </div>
      <FacebookShareButton href={url} onClick={onClick} />
      <TwitterShareButton url={url} onClick={onClick} />
      <EmailShareButton body={url} onClick={onClick} />
    </div>
  );
};
export default SocialShareButtons;
